module.exports = __webpack_public_path__ + "assets/hamburger_active-4b4939.svg";